import duplicateOrderGroup from '../../../Services/duplicateOrderGroup';

export default (params) => async (dispatch) => dispatch(duplicateOrderGroup(params))